<template>
  <div>
    <div class="announcements-container">
     <announcements></announcements>
     </div>
    <div class="align-center-signin">
      <!--element which is going to render the Card-->
      <div tabindex="0" class="e-card" id="basic" style="width: 70%">
        <div class="e-card-title">Sign In</div>
        <div class="e-card-separator"></div>
        <div class="e-card-content">
          <div style="padding-bottom: 5%; text-align: justify">
            <span style="color: red; display: block; margin-bottom: 2%;font-weight:bold">{{
              loginErorrMessage
            }}</span>
            <span style="color: chocolate;font-weight:bold;"> {{ preLockMessage }}</span>
          </div>
          <form class="login" @submit.prevent="login">
            <scc-input-validator
              :rules="[requiredRule, emailRule]"
              :value="this.username"
              @validate="(v) => (this.isEmailValid = v)"
            >
              <ejs-textbox
                data-test-sign-in="email"
                float-label-type="Always"
                placeholder="Enter Email"
                v-model="username"
                v-on:change="getMessage"
              />
            </scc-input-validator>
            &nbsp;
            <scc-input-validator
              :rules="[requiredRule]"
              :value="password"
              @validate="(v) => (this.isPasswordValid = v)"
            >
              <input-password
                data-test-sign-in="pswd"
                ref="refPassword"
                v-model="password"
                v-on:keydown.enter.native="onEnter"
                placeholder="Enter Password"
              />
            </scc-input-validator>
            <div class="align-right">
              <ejs-button cssClass="e-link" type="button" v-on:click.native="forgotPassword"
                >Forgot Password?</ejs-button
              >
            </div>
            &nbsp;
            <div class="e-card-actions e-card-vertical">
              <!-- <ejs-button type='submit'
                  ref='signInBtn'
                  cssClass='e-info e-card-btn'
                  style='height: 35px;'>SIGN IN</ejs-button> -->
              <ejs-progressbutton
                :content="content"
                type="submit"
                ref="progressbutton"
                data-test-sign-in="sbmt"
                cssClass="e-info"
                style="height: 35px; width: 100%"
                :enableProgress="true"
                :animationSettings="animationSettings"
                :begin="begin"
                :end="end"
                :click="login"
                :duration="duration"
              ></ejs-progressbutton>
            </div>
          </form>
          <div class="align-center-bottom-signup">
            <p style="margin: 10px">Don't have an account?</p>
            <ejs-button cssClass="e-link" v-on:click.native="signUpNow">SIGN UP NOW</ejs-button>
            &nbsp;
          </div>
        </div>
      </div>
    </div>
    <login-message :message="loginUserMessage" />
  </div>
</template>

<script>
import Vue from "vue";

import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { ProgressButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
// import { enableRipple } from '@syncfusion/ej2-base';
import { emailRule, requiredRule } from "@/shared/constants";
import inputPassword from "../../../components/base/input-password.vue";
import SccInputValidator from "../../../components/base/scc-input-validator.vue";
import LoginMessage from "../../notifications/components/login-message.vue";
import { getLoginUserMessage } from "../services/auth-api";
import Announcements from '../../announcements/public/announcements.vue';
import {
  SIGN_USER_IN,
  FETCH_LOGGED_USER,
  FETCH_USER_PERMISSION,
  FETCH_USER_SECURITY_QUESTIONS,
} from "../store";
import { GET_USER_PROFILES_BY_ID } from '../../user-accounts/store';
import outageManager from '../../outage/outage-manager';

// enableRipple(true);
Vue.use(TextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(ProgressButtonPlugin);

export default {
  name: "LoginPage",
  components: {
    SccInputValidator,
    inputPassword,
    LoginMessage,
    Announcements,
  },
  data() {
    return {
      username: null,
      password: null,
      requiredRule,
      emailRule,
      isEmailValid: false,
      isPasswordValid: false,
      loginCounter: 0,
      loginErorrMessage: null,
      // isForceChangePassword: false,
      animationSettings: { effect: "SlideUp", duration: 500, easing: "linear" },
      spinSettings: { position: "Center" },
      content: "SIGN IN",
      duration: 1500,
      navigationPath: "/",
      loginUserMessage: "",
      preLockMessage: "",
      defaultMessage:
        "Please sign into your account above by typing in your email address and password.  If you do not have an account set up already, please create your account under My Account.",
    };
  },
  created() {
    this.loginUserMessage = this.defaultMessage;
  },
  watch: {},
  computed: {
    userSequrityQuestions() {
      return this.$store.getters.userserSecurityQuestions || [];
    },
  },
  beforeRouteEnter(_, from, next) {
    next((thiss) => {
      const { query } = from;
      const permitTypeParam = query.permitType;
      if (permitTypeParam) {
        // eslint-disable-next-line no-param-reassign
        thiss.navigationPath = { name: "PermitApplication", query };
      }
    });
  },
  methods: {
    async getMessage(e) {
      if (e?.value) {
        const userName = e.value;
        // eslint-disable-next-line no-return-assign
        await getLoginUserMessage(userName).then((res) => {
          this.preLockMessage = res.data;
          this.loginErorrMessage = null;
        });
      }
    },
    async login() {
      this.duration = 15000;
      // this.$parent.notificationToasts.length = 0;
      const { username, password } = this;
      if (this.isEmailValid && this.isPasswordValid) {
        try {
          await this.$store.dispatch(SIGN_USER_IN, { username, password });
          await this.$store.dispatch(FETCH_LOGGED_USER);
          await this.$store.dispatch(FETCH_USER_PERMISSION);
          const { loggedUser, forceSecurityQuestionChange } = this.$store.getters;
          // console.log('loggedUser', loggedUser);
          if (loggedUser) {
            await this.$store.dispatch(GET_USER_PROFILES_BY_ID, { userId: loggedUser.id });
            const userProfile = this.$store.getters.userProfilesbyID;
            await this.$store.dispatch(FETCH_USER_SECURITY_QUESTIONS, { userId: loggedUser.id });
            let url = '';
            if (!loggedUser.isSCCUser && !userProfile.foip) {
              url = '/force-enter-foip';
            }
            let securityQuestionsApplied = false;
            if (!loggedUser.isSCCUser) {
              // eslint-disable-next-line max-len
              securityQuestionsApplied = this.userSequrityQuestions.length < 3 || (loggedUser.isForcePasswordChange && forceSecurityQuestionChange.enable);
              if (securityQuestionsApplied) {
                if (url) {
                  url += '?redirect=force-change-password&qp=enablesecurityQuestions';
                } else {
                  url = '/force-change-password?enablesecurityQuestions=true';
                }
              }
            }
            if (!securityQuestionsApplied && loggedUser.isForcePasswordChange) {
              if (url) {
                url += '?redirect=force-change-password';
              } else {
                url = '/force-change-password';
              }
            }
            if (url) {
              this.$router.push(url);
              return;
            }
            if (this.navigationPath.query) {
              this.navigationPath.query.username = loggedUser.name;
            }
            this.$router.push(this.navigationPath);
            outageManager.notifyLoginUserChange();
          } else {
            this.$parent.notificationToasts.push({
              title: "Error!",
              content: "Sorry, Something went wrong. Please try again later.",
              cssClass: "e-toast-danger",
              timeOut: 5000,
            });
          }
        } catch (err) {
          switch (err.status) {
            case 401:
              this.loginCounter += 1;
              this.loginErorrMessage = "You have entered an invalid username or password.";
              this.duration = 2000;
              // this.content = "Double check username and Password";
              await getLoginUserMessage(username).then((res) => {
                this.preLockMessage = res.data;
              });
              break;
            case 403:
              this.loginErorrMessage = "Your account is not active. Please try creating your account again and ensure to validate your email address to complete your account registration. If you are experiencing any issues, you can contact ASCA Storage Tanks at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca.";
              this.duration = 2000;
              // this.content = "Account is not Active";
              break;
            case 404:
              this.loginErorrMessage = "Your email or password is incorrect. Please try again.If you are experiencing any issues, please contact ASCA Tanks at ascatanks@safetycodes.ab.ca or by calling 1-888-413-0099.";
              this.duration = 2000;
              // this.content = "Account doesnot exist";
              break;
            case 422:
              this.loginErorrMessage = "System got an error, please contact eServices admin.";
              this.duration = 2000;
              // this.content = "Double check username and Password";
              break;
            case 423:
              this.loginErorrMessage = null;
              // 'Your accont is now locked.
              // You have exceeded the number of times to Sign In to your account.
              // Please contact our help desk to un-lock your account at 1-888-413-0099';
              this.duration = 2000;
              // this.content = "account is now locked";
              break;
            default:
              this.loginErorrMessage = "Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly.  If you continue to experience this issue, you can contact ASCA Storage Tanks at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca.";
              this.duration = 2000;
              // this.content = "System Error";
          }
          if (this.loginErorrMessage) {
            this.$parent.notificationToasts.push({
              title: "Error!",
              content: this.loginErorrMessage,
              cssClass: "e-toast-danger",
              timeOut: 5000,
            });
          }
        }
      } else {
        // to triger validation indicator for initially empty field
        this.password = this.password === null ? "" : this.password;
        this.username = this.username === null ? "" : this.username;
        this.duration = 2000;
        this.content = "Put Required Fields and Try Again";
      }

      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    onEnter(e) {
      e.preventDefault();
      e.stopPropagation();
      const submitBtn = this.$refs.progressbutton;
      submitBtn.click();
    },
    signUpNow() {
      this.$router.push("/register");
    },
    forgotPassword() {
      this.$router.push("/password");
    },
    begin() {
      // this.content = "Loading...";
    },
    end() {
      this.content = "Sign In";
      this.duration = 15000;
    },
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../../../assets/styles/eservices-base.css";
input::-ms-reveal,
input::-ms-clear {
  display: none;
}
#container {
  visibility: hidden;
}
.announcements-container {
   max-width: 70%;  /*to make it the same width as sign-in window */
   margin: 0 auto;
   margin-bottom: -25px;
}
</style>
